import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { WeatherService } from './weather.service';
import { WeatherUtils } from './weather-utils';

/**
 * Current weather component. Fetch data from https://openweathermap.org/ and display current forecast to user's location.
 */
@Component({
  selector: 'qm-weather',
  templateUrl: './weather.component.html',
  styleUrls: ['./weather.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WeatherComponent implements OnInit {

  /**
   * Current weather conditions
   */
  public weather: any;

  /**
   * Default constructor
   * @param {ChangeDetectorRef} changeDetector
   * @param {WeatherService} weatherService
   */
  constructor(private changeDetector: ChangeDetectorRef, private weatherService: WeatherService) {
  }

  /**
   * Angular initializer hook, fetch current weather conditions and cleanup data
   */
  ngOnInit() {
    console.log('Weather component initialized');
    this.weatherService.getWeatherForLocation().then(weather => {
      console.log('Current weather:', weather);
      weather.main.temp = Math.floor(weather.main.temp);
      this.weather = weather;
      this.changeDetector.markForCheck();
    });
  }

  /**
   * Get weather icon class for current weather
   * @returns {string}
   */
  public getIconClass(): string {
    return WeatherUtils.getIconClass(this.weather);
  }

}
